
export default function subnav() {

  function getHeight(el) {
    return el.offsetHeight + 'px';
  }

  function getDistance() {
    var topDist = h.offsetTop;
    return topDist;
  }

  var h = document.getElementById("sub-nav");

  if (!h) {
    return;
  }

  var height = getHeight(h);
  var p = document.querySelector(".sub-nav__sticky-placeholder");
  var stuck = false;
  var stickPoint = getDistance();

  var scrollFn = function(e) {
    var distance = getDistance() - window.pageYOffset;
    var offset = window.pageYOffset;

    if ( (distance <= 0) && !stuck) {
      h.classList.add("sticky");
      p.style.height = height;
      p.style.display = 'block';
      stuck = true;
    } else if (stuck && (offset <= stickPoint)){
      h.classList.remove("sticky");
      height = getHeight(h);
      p.style.display = 'none';
      stuck = false;
    }
  }

  window.addEventListener("scroll", _.throttle(scrollFn, 300));


  var subnavHeader = document.querySelector('.sub-nav__header');
  var subnavContent = document.querySelector('.sub-nav__content');

  subnavHeader.addEventListener('click', function(e) {

    if (subnavContent.classList.contains('sub-nav__content--visible')) {
      subnavHeader.classList.remove("sub-nav__header--open");
      subnavContent.classList.remove("sub-nav__content--visible");
    }
    else {
      subnavHeader.classList.add("sub-nav__header--open");
      subnavContent.classList.add("sub-nav__content--visible");
    }
  });

}
